import React from "react";
import styles from "./sectionGrid.module.scss"
import SectionTitle from "../SectionTitle/sectionTitle";

function SectionGrid({children, title, grey = false}) {
    return (
        <div className={`${styles.sectionGridContainer} ${grey ? styles.grey : null}`}>
            <SectionTitle text={title}/>
            <div className={styles.content}>
                {children}
            </div>
        </div>
    )
        ;
}

export default SectionGrid;
